import { notification } from 'antd';
import { call, debounce, put } from 'redux-saga/effects';

import { DEFAULT_DEBOUNCE_DELAY } from '#constants';
import BlackListService from '#services/BlackListService';

import { getBlackList, setBlackList, setLoading } from './';

function* getBlackListList(data) {
  try {
    yield put(setLoading(true));
    const agents = yield call(BlackListService.getList, data?.payload);
    yield put(setBlackList(agents));
  } catch (error) {
    notification.error({ message: error?.response?.data?.error?.message });
    yield put(setBlackList({ count: 0, result: [] }));
    yield put(setLoading(false));
  }
}

function* BlackListSaga() {
  yield debounce(DEFAULT_DEBOUNCE_DELAY, getBlackList.type, getBlackListList);
}

export default BlackListSaga;
